import { BtixConstant } from "../../constant";
export const initRegistrationForVip = function () {
    // 1. 対象ページ判定
    const vipCodeAreaForRegistration = document.getElementById("vip-code-area-for-only-registration");
    if (vipCodeAreaForRegistration === null) {
        if (BtixConstant.debugMode) {
            window.console.log("Not Found vipCodeAreaForRegistration");
        }
        return;
    }
    // 2. VIP Customerであれば、該当のVIP Codeを取得できるので、VIP Customerか判別する
    const registeredVipCode = vipCodeAreaForRegistration.dataset.vipCode;
    if (registeredVipCode === undefined || registeredVipCode === "") {
        if (BtixConstant.debugMode) {
            window.console.log("Not Vip Customer");
        }
        return;
    }
    // 3. VIP Customerに必要な処理を記載
    vipCodeAreaForRegistration.addEventListener("input", function () {
        // 3-1. 必要情報の取得
        const preCodeInput = document.getElementById("vip_code_1");
        const postCodeInput = document.getElementById("vip_code_2");
        const preCode = preCodeInput.value;
        const postCode = postCodeInput.value;
        const inputVipCode = preCode + postCode;
        const vipNotification = document.getElementById("vip-notification");
        if (inputVipCode.length !== 8) {
            // 3-2. 入力文字数がまだVIP Codeの8桁に到達してないので、切る
            vipNotification.classList.add("area-hide");
            return;
        }
        if (inputVipCode === registeredVipCode) {
            // 4. 入力されたVIP Codeが正しいので、その旨を表示する
            vipNotification.classList.remove("area-hide");
            return;
        }
        return;
    });
};
